import { useEffect, useState } from 'react';
import { DASHBOARD } from '../../../../types/enum';
import { formatDate, getCurrentWeekDates } from '../../../../lib/date';
import Goal from './goal';
import WeightProgress from './weightProgress';
import Challenge from './challenge';
import Habit from './habit';
import CurrentWeek from './currentWeek';
import Content from './content';

const Home = ({ user, refreshUser, handleCurrentSection }) => {
  const [currentWeeks, setCurrentWeeks] = useState([]);
  const [lastWeek, setLastWeek] = useState([]);
  const [selectedDate, setSelectedDate] = useState(formatDate(new Date()));

  useEffect(() => {
    setCurrentWeeks(getCurrentWeekDates());
    setLastWeek(
      getCurrentWeekDates(
        new Date(new Date().setDate(new Date().getDate() - 7))
      )
    );
  }, []);

  const handleSelectDate = (date) => () => {
    setSelectedDate(date);
  };

  return (
    <div className='space-y-3'>
      <Content />
      <CurrentWeek
        currentWeeks={currentWeeks}
        lastWeek={lastWeek}
        handleSelectDate={handleSelectDate}
        selectedDate={selectedDate}
      />
      <Habit
        user={user}
        refreshUser={refreshUser}
        selectedDate={selectedDate}
        onClick={handleCurrentSection(DASHBOARD.HABIT)}
      />
      <Goal
        selectedDate={selectedDate}
        handleSelectDate={handleSelectDate}
        currentWeeks={currentWeeks}
        onClick={handleCurrentSection(DASHBOARD.GOAL)}
      />
      <WeightProgress
        onClick={handleCurrentSection(DASHBOARD.WEIGHT_PROGRESS)}
      />
      <div className='grid grid-cols-2 gap-3'>
        <button
          className='rounded-xl bg-secondary aspect-square'
          onClick={handleCurrentSection(DASHBOARD.BODY_PROGRESS)}
        >
          <div className='text-xl font-bold text-white'>
            Body
            <br />
            Progress
          </div>
        </button>
        <button
          className='rounded-xl bg-secondary aspect-square'
          onClick={handleCurrentSection(DASHBOARD.MEASUREMENT_PROGRESS)}
        >
          <div className='text-xl font-bold text-white'>
            Measurement
            <br />
            Progress
          </div>
        </button>
        <Challenge onClick={handleCurrentSection(DASHBOARD.CHALLENGE)} />
      </div>
    </div>
  );
};

export default Home;
